/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const SearchRightStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M21.48 21.6759L16.68 16.8759M19.08 10.4759C19.08 15.1151 15.3192 18.8759 10.68 18.8759C6.04084 18.8759 2.28003 15.1151 2.28003 10.4759C2.28003 5.83674 6.04084 2.07593 10.68 2.07593C15.3192 2.07593 19.08 5.83674 19.08 10.4759Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { SearchRightStrokeIcon };
